import { useQuery } from '@tanstack/react-query'
import { api } from '../../utils/apiClient'
import { queryKeys } from './keys'

/**
 * Portal product drawer from Contentful (portalDrawer with ordered
 * ordered portalProductDisplay links). Cached for 1 hour, aligned with app copy.
 */
export function useProductDisplayConfigQuery(locale: string) {
  return useQuery({
    queryKey: queryKeys.productDisplay.config(locale),
    queryFn: async () => {
      const response = await api.getProductDisplayConfig(locale)
      return response?.data?.data ?? { items: [], includes: {} }
    },
    staleTime: 60 * 60 * 1000,
    gcTime: 2 * 60 * 60 * 1000,
  })
}

export default useProductDisplayConfigQuery
